var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "8pt",
    height: "16pt",
    fill: "none",
    viewBox: "0 0 8 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15 1.12 8.33A.5.5 0 0 1 1 8a.5.5 0 0 1 .12-.33L7 1"
  })));
};
export default SvgChevronLeft;